import { registerPlugin } from "@capacitor/core";
import { isNativeIOS } from "./runtime";

const externalPurchase = registerPlugin("NativeExternalPurchase");

export const getAppleExternalPurchaseAvailability = async () => {
  if (!isNativeIOS()) return { eligible: false, reason: "not_ios" };
  return externalPurchase.availability();
};

export const requestAppleExternalPurchaseTokens = async () => {
  if (!isNativeIOS()) throw new Error("Apple external purchase is only available in the iOS app.");
  const result = await externalPurchase.requestTokens();
  const tokens = Object.fromEntries(
    Object.entries(result?.tokens || {}).filter(
      ([type, value]) =>
        ["ACQUISITION", "SERVICES"].includes(type) &&
        typeof value === "string" &&
        value.length > 0
    )
  );
  if (!tokens.ACQUISITION || !tokens.SERVICES) {
    throw new Error("Apple did not provide both external purchase tokens.");
  }
  return {
    tokens,
    storefrontCountry: String(result?.storefrontCountry || "").toUpperCase(),
  };
};

export const showAppleExternalBrowserNotice = async () => {
  if (!isNativeIOS()) throw new Error("Apple external purchase is only available in the iOS app.");
  const result = await externalPurchase.showBrowserNotice();
  return Boolean(result?.continued);
};
